(() => {
  const svgNS='http://www.w3.org/2000/svg';
  const format=(value,digits)=>Number.isFinite(value)?value.toLocaleString('en-US',{minimumFractionDigits:digits,maximumFractionDigits:digits}):'—';
  document.querySelectorAll('[data-dyno-chart]').forEach(chart=>{
    if(chart.dataset.dynoReady)return;
    const points=JSON.parse(chart.querySelector('[data-dyno-points]').textContent).points;
    if(!points.length)return;
    const figure=chart.closest('.example-graph');
    const make=(tag,attributes)=>{
      const element=document.createElementNS(svgNS,tag);
      Object.entries(attributes).forEach(([name,value])=>element.setAttribute(name,value));
      return element;
    };
    const plots=[...chart.querySelectorAll('[data-example-graph]')].map(svg=>{
      const rect=svg.querySelector('clipPath rect');
      const number=label=>Number(label.textContent.replace(/,/g,''));
      const horizontal=[...svg.querySelectorAll('.axis-label[text-anchor="middle"]')];
      const vertical=[...svg.querySelectorAll('.axis-label[text-anchor="end"]')];
      const left=Number(rect.getAttribute('x')),top=Number(rect.getAttribute('y'));
      const width=Number(rect.getAttribute('width')),height=Number(rect.getAttribute('height'));
      const xMin=number(horizontal[0]),xMax=number(horizontal.at(-1));
      const yMin=Math.min(...vertical.map(number)),yMax=Math.max(...vertical.map(number));
      const overlay=make('g',{'data-dyno-cursor':'','aria-hidden':'true',class:'dyno-cursor'});
      const line=make('line',{x1:left,x2:left,y1:top,y2:top+height,class:'dyno-crosshair'});
      const dots={power:make('circle',{'data-cursor-channel':'power',r:6}),torque:make('circle',{'data-cursor-channel':'torque',r:6})};
      overlay.append(line,dots.power,dots.torque);svg.append(overlay);
      return {svg,left,top,width,height,xMin,xMax,yMin,yMax,line,dots};
    });
    let index=0,touchPointer=null;
    function select(next){
      index=Math.max(0,Math.min(points.length-1,next));
      const point=points[index];
      chart.dataset.pointIndex=String(index);
      chart.setAttribute('aria-valuenow',String(point.rpm));
      chart.setAttribute('aria-valuetext',`${format(point.rpm,0)} RPM; ${format(point.power,1)} WHP; ${format(point.torque,1)} lb-ft`);
      figure.querySelector('[data-dyno-rpm]').textContent=format(point.rpm,0);
      figure.querySelector('[data-dyno-power]').textContent=format(point.power,1);
      figure.querySelector('[data-dyno-torque]').textContent=format(point.torque,1);
      plots.forEach(plot=>{
        const x=plot.left+(point.rpm-plot.xMin)/(plot.xMax-plot.xMin)*plot.width;
        plot.line.setAttribute('x1',x);plot.line.setAttribute('x2',x);
        for(const channel of ['power','torque']){
          const dot=plot.dots[channel],value=point[channel];
          dot.style.display=Number.isFinite(value)?'':'none';
          if(Number.isFinite(value)){
            dot.setAttribute('cx',x);
            dot.setAttribute('cy',plot.top+plot.height-(value-plot.yMin)/(plot.yMax-plot.yMin)*plot.height);
          }
        }
      });
    }
    function selectAtPointer(event){
      const plot=plots.find(item=>item.svg.getClientRects().length&&getComputedStyle(item.svg).display!=='none');
      if(!plot)return;
      const matrix=plot.svg.getScreenCTM();
      if(!matrix)return;
      const cursor=plot.svg.createSVGPoint();cursor.x=event.clientX;cursor.y=event.clientY;
      const position=cursor.matrixTransform(matrix.inverse());
      const fraction=Math.max(0,Math.min(1,(position.x-plot.left)/plot.width));
      const rpm=plot.xMin+fraction*(plot.xMax-plot.xMin);
      let nearest=0,distance=Infinity;
      points.forEach((point,i)=>{const delta=Math.abs(point.rpm-rpm);if(delta<distance){nearest=i;distance=delta;}});
      select(nearest);
    }
    chart.addEventListener('pointerdown',event=>{
      if(event.pointerType==='mouse'&&event.button!==0)return;
      if(event.pointerType==='touch'){
        touchPointer=event.pointerId;
        chart.setPointerCapture(event.pointerId);
      }
      selectAtPointer(event);
    },{passive:true});
    chart.addEventListener('pointermove',event=>{
      if(event.pointerType!=='touch'||touchPointer===event.pointerId)selectAtPointer(event);
    },{passive:true});
    const finish=event=>{if(touchPointer===event.pointerId)touchPointer=null;};
    chart.addEventListener('pointerup',finish,{passive:true});
    chart.addEventListener('pointercancel',finish,{passive:true});
    chart.addEventListener('lostpointercapture',finish,{passive:true});
    chart.addEventListener('keydown',event=>{
      const next={ArrowLeft:index-1,ArrowDown:index-1,ArrowRight:index+1,ArrowUp:index+1,Home:0,End:points.length-1}[event.key];
      if(next===undefined)return;
      event.preventDefault();select(next);
    });
    select(0);chart.dataset.dynoReady='true';
  });
})();
